import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full rounded-md max-h-60 overflow-hidden",
  style:  `padding-bottom: 100%;` 
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "border-2 border-gray-blue-500 dark:border-gray-bluer-500 m-3 rounded-md p-3 text-sm font-medium text-center"
}
const _hoisted_4 = { class: "py-2 px-3 flex justify-between space-x-3" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Change ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Remove ")
const _hoisted_7 = { class: "block border-gray-blue-500 dark:border-gray-bluer-500 border-2 bg-white dark:bg-gray-bluer-900 text-sm font-medium text-center px-3 py-2 rounded-md group-hover:bg-theme group-hover:text-white transition duration-150 ease-in-out" }

import { toRefs, ref, onMounted, computed, watch } from "vue";
import { useStore } from "vuex";
import { userHook } from "@/hooks/user";
import { MediaModel as Media } from "@greywind/common";
import { AppModal as Modal, AppFieldDefault, useFieldHook } from "@greywind/ui";
import { MediaLibrary as Library } from "../";
import { cloneDeep } from 'lodash';


export default /*#__PURE__*/_defineComponent({
  props: {
        field: {
            type: Object,
            required: true
        },
        error: [String, Boolean],
        inputClass: String,
        modelValue: {},
        buttonText: {
            type: String,
            default: "Select File"
        }
    },
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props


const { buttonText, field, error, inputClass, modelValue } = toRefs( props );



const store = useStore();
const { activeEnvironment } = userHook( store );

const model = ref( null );
const loading = ref( false );
const selecting = ref( false );
const path = ref( '' );
const file = ref( null );

const { formField, value, isReadonly } = useFieldHook(
    {
        emit, field, error, inputClass, modelValue
    }, '' );

const defaultAttributes = computed( () => (
    {
        extensions: field.value.extensions || []
    }
) );
const extraAttributes = computed( () => (
    {
        ...( defaultAttributes.value || {} ),
        ...( field.value.extraAttributes || {} )
    }
) );
const files = computed( () => store.getters["media/files"] );
const fieldName = computed( () => store.getters["media/fieldName"] );

onMounted( (): void => {
    model.value = new Media( 'denfield-app-user/denfield-package-media', activeEnvironment.value.meta.api.url );

    if ( modelValue.value ) {
        if (typeof modelValue.value === "object") {
            file.value = cloneDeep(modelValue.value);
            value.value = file.value[field.value.key || 'id'];
            emit('update:modelValue', value.value);
        } else {
            findFile(modelValue.value);
        }
    }
} );

watch( () => modelValue.value, ( val ) => findFile( val.id ?? val ), { deep: true } );

const setFile = (f): void => {
    file.value = f;
    value.value = f[field.value.key || 'id'];
    emit( 'update:modelValue', value.value );
    selecting.value = false;
}

const open = async (): Promise<void> => {
    await store.dispatch( "media/setFieldName", field.value.name );
    selecting.value = true;
};

const remove = (): void => {
    file.value = null;
    value.value = '';
    path.value = '';
    store.dispatch( "media/setFile", null );
    emit( 'update:modelValue', value.value );
};

const findFile = async ( id ): Promise<void> => {
    loading.value = true;

    await model.value.find( id )
        .then(async ( response ) => {
            const { data } = response;

            path.value = data.file_path;
            file.value = data;
            await store.dispatch( "media/setFile", data );
        })
        .catch(( error ) => {});

    loading.value = false;
}


return (_ctx: any,_cache: any) => {
  const _component_x_icon = _resolveComponent("x-icon")!

  return (_openBlock(), _createBlock(_unref(AppFieldDefault), {
    field:  _unref(field) ,
    error:  _unref(error) 
  }, {
    field: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["relative rounded-sm shadow-sm",  { 'max-w-xs': file.value && _unref(value) } ]),
        ref_key: "formField",
        ref: formField
      }, [
        ( file.value )
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "border-2 border-dashed border-gray-blue-500 dark:border-gray-bluer-500 rounded-md hover:border-theme transition duration-150 ease-in-out cursor-pointer",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ( open  &&  open (...args)))
            }, [
              ( file.value.is_image )
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("img", {
                      src:  file.value.url ,
                      class: "w-full h-full object-cover rounded-md"
                    }, null, 8, _hoisted_2)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(file.value.name || file.value.file_name), 1)),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", {
                  class: "flex items-center text-xs font-medium hover:text-theme transition duration-150 ease-in-out cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => ( open  &&  open (...args)), ["stop"]))
                }, [
                  _createVNode(_component_x_icon, {
                    icon: "fontawesome.arrow-rotate-right",
                    class: "w-4 h-4 mr-1"
                  }),
                  _hoisted_5
                ]),
                _createElementVNode("span", {
                  class: "flex items-center text-xs font-medium hover:text-red-600 transition duration-150 ease-in-out cursor-pointer",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => ( remove  &&  remove (...args)), ["stop"]))
                }, [
                  _createVNode(_component_x_icon, {
                    icon: "fontawesome.trash",
                    class: "w-4 h-4 mr-1"
                  }),
                  _hoisted_6
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["group border-2 bg-gray-blue-300 dark:bg-gray-bluer-800 rounded-md transition duration-150 ease-in-out cursor-pointer p-3",  { 'border-gray-blue-500 dark:border-gray-bluer-500': !_unref(error), 'border-red-500': _unref(error) } ]),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ( open  &&  open (...args)))
            }, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(buttonText)), 1)
            ], 2)),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          _createVNode(_unref(Modal), {
            open:  selecting.value ,
            onClose: _cache[4] || (_cache[4] = ($event: any) => ( selecting.value = false )),
            "width-classes": "sm:max-w-4xl sm:w-full",
            "inner-border":  false ,
            style: {"z-index":"9999999"},
            "close-style": "overlap"
          }, {
            default: _withCtx(() => [
              ( selecting.value )
                ? (_openBlock(), _createBlock(_unref(Library), _mergeProps({
                    key: 0,
                    "can-upload":  true ,
                    "can-delete-folder":  false ,
                    "can-replace":  false ,
                    "can-download":  false ,
                    "can-bulk-upload":  false ,
                    previews:  false ,
                    presence:  false ,
                    mode: "BrandMediaLibrary"
                  },  _unref(extraAttributes) , {
                    "initial-file":  file.value ,
                    "initial-path":  path.value ,
                    onSelected: setFile
                  }), null, 16, ["initial-file", "initial-path"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["open"])
        ]))
      ], 2)
    ]),
    _: 1
  }, 8, ["field", "error"]))
}
}

})